<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="col-12" xLayout="row" fxLayoutAlign="space-between">
        <span>Athlete Resumen</span>
        <mat-icon class="mobile" (click)="onClose()" style="cursor: pointer;">close</mat-icon>
      </div>
    </div>

  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-8 col-avatar">
        <div class="avatar">
          <mat-progress-spinner color="accent" mode="indeterminate" diameter="25" *ngIf="isLoadingProfileImg"
            style="margin: auto;">
          </mat-progress-spinner>
          <img class="img-dimension" [src]="profileImg ? profileImg : defaultProfileImg" alt="Profile Pic"
            *ngIf="!isLoadingProfileImg">
        </div>
      </div>
    </div>

    <div class="step-info-container">
      <span class="subtitle">Basic Information</span>
      <hr>
      <div class="row">
        <div class="col-12 m-t-5">
          <span class="info-title">Email (Account identifier)</span> <br>
          <span class="info-detail">{{data.email ? data.email : incompleteMessage}}</span>
        </div>
        <div class="col-12 col-md-6 ">
          <span class="info-title">First Name</span> <br>
          <span class="info-detail">{{data.firstName ? data.firstName : incompleteMessage}}</span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Last Name</span> <br>
          <span class="info-detail">{{data.lastName ? data.lastName : incompleteMessage}}</span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Birthdate</span> <br>
          <span class="info-detail" *ngIf="data.birthDate">{{data.birthDate | date: 'MMM dd, yyyy'}}</span>
          <span class="info-detail" *ngIf="!data.birthDate">{{incompleteMessage}}</span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Identify As</span> <br>
          <span class="info-detail" style="text-transform: capitalize;">{{data.gender.toLowerCase()}}</span>
        </div>
      </div>
    </div>

    <div class="step-info-container">
      <span class="subtitle">Contact Information</span>
      <hr>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 m-t-5">
          <span class="info-title">Country</span> <br>
          <span class="info-detail">{{data.address ? data.address.country.value : isLoading ? '' : incompleteMessage
            }}</span>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <span class="info-title">State</span> <br>
          <span class="info-detail">{{data.address ? data.address.state.value : isLoading ? '' : incompleteMessage
            }}</span>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <span class="info-title">City</span> <br>
          <span class="info-detail">{{data.address ? data.address.city : isLoading ? '' : incompleteMessage }}</span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Street address</span> <br>
          <span class="info-detail">{{data.address ? data.address.street : isLoading ? '' : incompleteMessage
            }}</span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Suite or #</span> <br>
          <span class="info-detail">{{data.address ? data.address.numberSuite ? data.address.numberSuite : 'NA' :
            isLoading ? '' : incompleteMessage }}</span>
        </div>

        <div class="col-12 col-md-6">
          <span class="info-title">Zip Code</span> <br>
          <span class="info-detail">{{data.address ? data.address.zipCode: isLoading ? '' : incompleteMessage }}</span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Contact Number</span> <br>
          <span class="info-detail">{{data.phone ? data.phone : incompleteMessage }}</span>
        </div>
      </div>
    </div>
    
    <div class="step-info-container">
      <span class="subtitle">Doctor contact information</span>
      <hr>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 m-t-5">
          <span class="info-title">Name</span> <br>
          <span class="info-detail"> {{ data.doctorName ? data.doctorName : '' }} </span>
        </div>
        <div class="col-12 col-md-6">
          <span class="info-title">Contact Number</span> <br>
          <span class="info-detail">{{ data.doctorPhone ? data.doctorPhone : '' }}</span>
        </div>
      </div>
    </div>

    <div class="step-info-container">
      <span class="subtitle">Biologican Info</span>
      <hr>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 m-t-5">
          <span class="info-title">Feets</span> <br>
          <span class="info-detail">{{data.heightFeet ? data.heightFeet : isLoading ? '' : incompleteMessage
            }}</span>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <span class="info-title">Inches</span> <br>
          <span class="info-detail">{{data.heightInches ? data.heightInches : isLoading ? '' : incompleteMessage
            }}</span>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <span class="info-title">Pounds</span> <br>
          <span class="info-detail">{{data.weight ? data.weight : isLoading ? '' : incompleteMessage }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="sports.length" class="step-info-container">
      <span class="subtitle">Club Selection</span>
      <div class="row p-t-20">
        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 container-mat-toggle-group-sport">
          <mat-button-toggle-group class="row mat-toggle-group-sport" (change)="onChangeTabSport()" [(ngModel)]="sportSelected">
            <mat-button-toggle *ngFor="let sport of sports" 
            [ngClass]="{ 'col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12': sports.length >= 3, 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12': sports.length == 2, 'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12': sports.length == 1}" [value]="sport">{{sport.desc}}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <hr>
      <div class="row" *ngIf="sportSelected && !sportSelected.club && !sportSelected.incomplete">
        <div class="divEmptyData">
          Independent Athlete.
        </div>
      </div>
      <div class="mobile-overflow">
        <div class="row m-t-20">       
            <ngx-position-athlete [header_description]="sportSelected && sportSelected.club ? true : false" [sport]="sportSelected" [menu_action]="false" [isDialog]="false" [isCoach]="isCoach"></ngx-position-athlete>
        </div>
      </div>
        <div class="row" *ngIf="!sportSelected.club && sportSelected.incomplete">
          <div class="divEmptyData">
            {{incompleteMessage}}
          </div>
        </div>
    </div>

    <div class="step-info-container">
      <span class="subtitle">Identification Document</span>
      <hr>
      <div class="row">
        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-8 img-col">
          <div class="img-container">
            <div class="img-content">
              <img [src]="documentImg ? documentImg : defaultImg" alt="DocumentID" *ngIf="!isLoadingDocumentImg">
              <mat-progress-spinner *ngIf="isLoadingDocumentImg" color="accent" mode="indeterminate" diameter="30"
                style="margin: auto;">
              </mat-progress-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="step-info-container last-item">
      <span class="subtitle">Birth Certificate Document</span>
      <hr>
      <div class="row">
        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-8 img-col">
          <div class="img-container">
            <div class="img-content">
              <img [src]="birthCertImg ? birthCertImg : defaultImg" alt="BirthCert" *ngIf="!isLoadingBirthCertImg">
              <mat-progress-spinner *ngIf="isLoadingBirthCertImg" color="accent" mode="indeterminate" diameter="30"
                style="margin: auto;">
              </mat-progress-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>



  </nb-card-body>
  <nb-card-footer class="desktop">
    <div class="modal-footer">
      <button nbButton matRipple status="primary" (click)="onClose()">Close</button>
    </div>
  </nb-card-footer>
</nb-card>